import { render, staticRenderFns } from "./SettingsBubble.vue?vue&type=template&id=476f6f22&"
import script from "./SettingsBubble.vue?vue&type=script&lang=ts&"
export * from "./SettingsBubble.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsBubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsBubble.vue"
export default component.exports